const validateHttpResponse = (response, validatePayload = false) => {
  if (!response) return false;
  if (response.statusCode !== 200) return false;
  if (validatePayload && (response.payload === null || response.payload === "")) return false;
  return true;
};

const validateIsraelMobilePhone = (phone) => {
  const israeliMobileRegex = /^05[0-9]{8}$/;
  return israeliMobileRegex.test(phone);
};

const valudateEmailAddress = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const validationHelper = { validateHttpResponse, validateIsraelMobilePhone, valudateEmailAddress };

export default validationHelper;
